<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Header -->
  <div class="flex justify-between items-center p-4 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
        <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <!-- Close button -->
    <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2" *ngIf="shouldShowCloseButton()"
      data-testid="close-dialog-btn" aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
    
  </div>

  <!-- Main Content - Enhanced for better space distribution -->
  <div class="flex-grow flex flex-col h-full px-4 mb-4">
    <!-- Top section with title and text -->
    <div class="flex flex-col items-center justify-center w-full pt-6 ">
      <h1 class="text-3xl sm:text-3xl font-extrabold leading-tight text-center">
        {{ 'register.title' | transloco }}
      </h1>
      <div class="mt-0.5 text-base sm:text-base font-medium text-gray-500 text-center" style="color:#567476;">
        {{ 'register.subtitle' | transloco }}<br />
        <span class="font-semibold" >{{ 'register.subtitle2' | transloco }}</span>
      </div>
    </div>
    
    <!-- Middle Section - Flexible space -->
    <form [formGroup]="registerForm" autocomplete="off">
  <div class="flex-grow flex flex-col justify-center items-center min-h-[20vh] sm:min-h-[15vh] mt-6 mb-1">
    <!-- Email input -->
    <div class="w-full max-w-2xl floating-label mb-0">
      <input
        type="email"
        formControlName="email"
        id="name"
        [placeholder]="'login.emailPlaceholder' | transloco"
        autocomplete="off" 
        class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
        [ngClass]="{'border-gray-300': !emailControl.invalid || !emailControl.touched, 'border-red-500': emailControl.invalid && emailControl.touched}"
        data-testid="register-email-input"
      />
      <label for="name" class="floating-label">{{'login.emailPlaceholder' | transloco}}</label>
    </div>
    
    <!-- Error messages container similar to login dialog -->
    <div class="mt-1 ml-2 w-full max-w-2xl">
      <!-- Validation errors -->
      <div *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)" class="text-base text-red-500">
        <div *ngIf="emailControl.errors?.['required']" class="flex items-center">
          <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <span>{{ 'login.emailMissing' | transloco }}</span>
        </div>
        <div *ngIf="emailControl.errors?.['email']" class="flex items-center">
          <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <span>{{ 'validations.invalidEmailFormat' | transloco }}</span>
        </div>
        <div *ngIf="emailControl.errors?.['containsSpaces']" class="flex items-center">
          <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <span>{{ 'login.blankSpaces' | transloco }}</span>
        </div>
      </div>
      
      <!-- API Error -->
      <div *ngIf="emailError" class="text-base text-red-500 flex items-center">
        <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
        <span>{{ emailError | transloco }}</span>
      </div>
    </div>
  </div>
</form>
    <!-- Bottom section with button and text -->
    <div class="flex-grow w-full max-w-2xl mx-auto mt-auto pb-6 ">
      <button 
        (click)="continue()"
        class="w-full my-button py-4 text-white rounded-full font-semibold text-base md:text-base transition h-14 shadow btnactions-base bg-teal-700 hover:bg-teal-800"
        [disabled]="isSubmitting"
        type="submit"
        data-testid="register-continue-btn"
      >
        <div class="flex items-center justify-center">
          <div *ngIf="isSubmitting" class="mr-2">
            <mat-spinner [diameter]="20" style="--mdc-circular-progress-active-indicator-color: white;"></mat-spinner>
          </div>
          <span>{{ isSubmitting ? ('register.checking' | transloco) : ('register.continue' | transloco) }}</span>
          <svg *ngIf="!isSubmitting" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H7a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </div>
      </button>
      <p class="text-base mt-3 text-center">
        {{ 'register.accountExist' | transloco }}
        <button (click)="backLoginDialog()" class="text-[#006E75] hover:text-[#003E42] hover:underline underline"
          data-testid="back-to-login-link">
          {{ 'login.loginBtn' | transloco }}
        </button>
      </p>
    </div>
  </div>
</div>